module.exports = __webpack_public_path__ + "img/recording_img2.4bba94d5.png";